import { apiRequest } from '../../utilities/apiHelper';

export async function getIntegrationDataFieldsApi(organizationId) {
  const url = `${organizationId}/integration-data/data-fields`;
  return await apiRequest('GET', url, null, false);
}

export async function getDataIntegrationsApi(organizationId) {
  const url = `${organizationId}/integration-data`;
  return await apiRequest('GET', url, null, false);
}

export async function createDataIntegrationApi(organizationId, data) {
  const url = `${organizationId}/integration-data`;
  return await apiRequest('POST', url, data, false);
}

export async function updateDataIntegrationApi(organizationId, id, data) {
  const url = `${organizationId}/integration-data/${id}`;
  return await apiRequest('PATCH', url, data, false);
}

export async function deleteDataIntegrationApi(organizationId, id) {
  const url = `${organizationId}/integration-data/${id}`;
  return await apiRequest('DELETE', url, null, false);
}

export async function getDataIntegrationById(organizationId, id) {
  const url = `${organizationId}/integration-data/${id}`;
  return await apiRequest('GET', url, null, false);
}
